import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { isLoadingSelectorLeave } from 'store1/leaves data/leavesData.Slice.Selector';
import { startAllMyLeavesData } from "store1/leaves data/leavesData.Slice.Selector";
import MyLeavesData from "./LeavesList/myLeaveList";

const MyLeavesDataWrapper = () => {
    const dispatch = useDispatch();
    const isLoadingLeave = useSelector(isLoadingSelectorLeave);
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(startAllMyLeavesData({
            pageSize: 10,
            pageIndex: 1,
            start_date: "",
            end_date: "",
            approval_status: -1
        }));
    }, [dispatch]);


    return <MyLeavesData isLoadingLeave={isLoadingLeave} navigate={navigate} />;
};

export default MyLeavesDataWrapper;
